// Currency conversion for the price comparison (base prices are in USD).
// Rates are static/indicative; final price is always confirmed at the registrar.
export const CURRENCIES = {
  USD: { symbol: "$", rate: 1 },
  AUD: { symbol: "A$", rate: 1.53 },
  GBP: { symbol: "\u00A3", rate: 0.79 },
};

export const CURRENCY_CODES = ["USD", "AUD", "GBP"];

export function formatMoney(usd, code) {
  const c = CURRENCIES[code] || CURRENCIES.USD;
  return `${c.symbol}${(usd * c.rate).toFixed(2)}`;
}
